import { GetLocalPublicMemberStations } from 'types/graphql'

import Station from './Station'

export interface StationsData {
  stations: GetLocalPublicMemberStations['stations']
}

interface StationsProps {
  data: StationsData
}

const Stations = ({ data }: StationsProps) => {
  return (
    <table className="w-full whitespace-nowrap text-left">
      <colgroup>
        <col className="w-4/12" />
        <col className="w-4/12" />
        <col className="w-2/12" />
        <col className="w-2/12" />
        <col className="w-2/12" />
      </colgroup>
      <thead className="border-gray-200 text-gray-900">
        <tr>
          <th scope="col" className="px-3 py-4 font-semibold">
            Logo
          </th>
          <th scope="col" className="px-3 py-4 font-semibold">
            Name
          </th>
          <th scope="col" className="px-3 py-4 font-semibold">
            Call sign
          </th>
          <th scope="col" className="px-3 py-4 font-semibold">
            Demo
          </th>
          <th scope="col" className="px-3 py-4 font-semibold">
            Operations
          </th>
        </tr>
      </thead>
      <tbody className="divide-y divide-gray-100">
        {data.stations.map((station) => (
          <Station key={station.id} station={station} />
        ))}
      </tbody>
    </table>
  )
}

export default Stations
